<ngb-toast *ngFor="let toast of toastService.toasts" [header]="toast.headertext" [autohide]="toast.autohide"
    (mouseenter)="toast.autohide = false" (mouseleave)="toast.autohide = true; toast.delay = 1000"
    [delay]="toast.delay || 5000" (hide)="toastService.remove(toast)">

    <ng-template [ngIf]="isTemplate(toast)" [ngIfElse]="text">
        <ng-template></ng-template>
    </ng-template>

    <ng-template #text>
        <div class="alert w-100 d-flex justify-content-between align-items-center text-center" [ngClass]="toast.classname" role="alert">            
        <div class="flex-grow-1 text-center">
            {{ toast.textOrTpl }}
        </div>
            <button *ngIf="toast.closebtn" type="button" class="ms-2 mb-1 btn-close" data-bs-dismiss="toast"
                (click)="close(toast)" aria-label="Close">               
            </button>          
        </div>
    </ng-template>
</ngb-toast>
